module.exports = __webpack_public_path__ + "static/media/img12.7210c92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/img12.png
// module id = 103
// module chunks = 0